import dayjs from "dayjs";

import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import { nationStorage } from "./storage";

export const dayjsPlus = dayjs.extend(weekday, localeData);

export function formatTime(
  time: number | undefined | null,
  format: string = "YYYY-MM-DD HH:mm:ss"
) {
  if (!time) {
    return "-";
  }
  return dayjs(time).format(format);
}

export function formatTimeYYMMDD(time: number) {
  return formatTime(time, "YYYY-MM-DD");
}

export function formatTimeDay(time: number) {
  return formatTime(time, "HH:mm:ss");
}
export function formatTimeDayYear(time: number) {
  return formatTime(time, "ssmmHH_DDMMYYYY");
}
export function langPrefix(obj: Record<string, string>, str: string) {
  const result: Record<string, string> = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[str + "." + key] = obj[key];
    }
  }
  return result;
}
export function formatCalculatePercentage(value1, value2) {
  // 检查是否有任一参数缺失或为无效数值
  if (value1 === undefined || value1 === null || value2 === undefined || value2 === null) {
    return 0;
  }

  // 尝试将参数转换为数值
  const num1 = parseFloat(value1);
  const num2 = parseFloat(value2);

  // 检查转换后是否为有效数字
  if (isNaN(num1) || isNaN(num2) || num2 === 0) {
    return 0;
  }

  // 计算百分比并保留两位小数
  return Math.round((num1 / num2) * 10000) / 100;
}
export function formatMoney(val = 0) {
  const num = Number(val).toFixed(2).toString();
  let result = num;
  const [zheng, decimals] = num.split(".");
  if (num.length > 5) {
    result = `${zheng.replace(/(\d)(?=(\d{3})+$)/g, "$1,")}.${decimals}`;
  }
  return result;
}
// 小数点
export function formatPrice(price: any) {
  if (!price && price !== 0) {
    return 0;
  }
  let newPrice = price;
  if (typeof price === "string" && price.includes("฿")) {
    newPrice = price.replace(/[฿,]/g, "");
  } else if (typeof price === "string" && price.includes("₫")) {
    newPrice = price.replace(/[₫.]/g, "");
  }
  if (nationStorage.get() === "VI") {
    if (Number.isNaN(+newPrice) || newPrice === "") {
      return "0";
    }
    // 使用 Math.floor(price) 取整并转换为字符串
    return Math.floor(+newPrice).toString();
  }
  if (Number.isNaN(+newPrice) || newPrice === "") {
    return "0.00";
  }
  // 对价格保留两位小数并转换为字符串
  return parseFloat(newPrice).toFixed(2);
}
export function PriceSuffix() {
  if (nationStorage.get() == "VI") {
    return "VND";
  }
  return "THB";
}
export function formatNum(val = 0) {
  if (!val && val !== 0) {
    return 0;
  }
  if (nationStorage.get() == "VI") {
    return `${(Math.floor(val) + "").replace(/(\d)(?=(\d{3})+$)/g, "$1.")}`;
  }
  return `${val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

export function formatInteger(val: number = 0): string {
  if (!val && val !== 0) {
    return "0";
  }

  const nation = nationStorage.get();

  if (nation === "VI") {
    // 越南用点号作为千分位
    return Math.floor(val)
      .toString()
      .replace(/(\d)(?=(\d{3})+$)/g, "$1.");
  }

  // 默认用英文逗号千分位
  return Math.floor(val)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function unformatNum(val: string | number | null | undefined): number {
  if (val == null) {
    return 0;
  }

  const strVal = String(val); // 强制转字符串

  const nation = nationStorage.get();
  if (nation === "VI") {
    return parseInt(strVal.replace(/\./g, ""), 10);
  }
  return parseFloat(strVal.replace(/,/g, ""));
}

export function formattHousandth(val = 0) {
  return `${(val + "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

export function formatPriceMillennials(price: any) {
  return formatNum(parseFloat(formatPrice(price)));
}

// 时间戳转换成那天的第一秒
export function timestampToTodayStart(timestamp: any) {
  const yyyymmdd = new Date(timestamp).toISOString().split("T")[0];
  const year = yyyymmdd.split("-")[0];
  const month = yyyymmdd.split("-")[1];
  const day = yyyymmdd.split("-")[2];
  return new Date(`${month}/${day}/${year} 00:00:00`).getTime();
}

// 时间戳转换成那天的最后一秒
export function timestampToTodayEnd(timestamp: any) {
  const yyyymmdd = new Date(timestamp).toISOString().split("T")[0];
  const year = yyyymmdd.split("-")[0];
  const month = yyyymmdd.split("-")[1];
  const day = yyyymmdd.split("-")[2];
  return new Date(`${month}/${day}/${year} 23:59:59`).getTime();
}
// 示例方法，没有实际意义
export function trim(str: string) {
  return str.trim();
}

// 移除非数字字符串
export function converToNumber(value: string) {
  let res = value.replace(/\D/g, "");
  if (res.startsWith("0")) {
    res = res.replace(/0+/g, "0");
  }
  return res;
}
export const formatUnit = (num?: number, placeholder = "", isNeedZero = false) => {
  if (!num && !isNeedZero) {
    return placeholder;
  }

  if (num || num === 0) {
    if (num >= 1000000) {
      const million = num / 1000000;
      return (Number.isInteger(million) ? million : million.toFixed(1)) + "M";
    } else if (num >= 1000) {
      const thousand = num / 1000;
      return (Number.isInteger(thousand) ? thousand : thousand.toFixed(1)) + "K";
    }
    return num.toString();
  }

  return placeholder;
};

export function currencyUnit(price?: any) {
  if (nationStorage.get() == "TH") {
    return "฿" + price;
  }
  return price + "₫";
}

//字符串型数字转化为数字类型并去掉千分位
export function numberWithCommas(value: string) {
  console.log(value, "value");
  const numberWithoutCommas = parseFloat(value.replace(/,/g, ""));
  return numberWithoutCommas;
}

export function getActualParam(value: string) {
  if (value !== undefined && value !== null && value !== "") {
    const prefix = "【x】-";
    if (value.startsWith(prefix)) {
      return value.slice(prefix.length);
    }
  }
  return value;
}
